import React, { useRef, useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { ToastContainer, toast } from 'react-toastify'
import { removeNotification } from './notificationActions'

const Notifier = () => {
  const dispatch = useDispatch()
  const notifications = useSelector((state) => state.notifications)
  const shownRef = useRef(new Set())

  useEffect(() => {
    notifications.forEach((notification, key) => {
      if (shownRef.current.has(key)) return

      shownRef.current.add(key)

      toast(
        <span className='notification-message'>{ notification.message }</span>,
        {
          position: 'top-center',
          type: notification.level,
          autoClose: 5000,
          closeButton: true,
          onClose: () => {
            shownRef.current.delete(key)
            dispatch(removeNotification(key))
          },
        },
      )
    })
  }, [notifications, dispatch])

  return <ToastContainer className='notification-container' />
}

export default Notifier
